import axios from "axios";
import noUiSlider from 'nouislider';
import '../assets/css/slider.css';
const siteURL = window.location.origin;
const apiURL = 'https://api2.comprasocial.me/tiktok/';
const apiUserEndpoint = 'user';
const apiUserFeedEndpoint = 'userFeed';

axios.defaults.headers = {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
  };

export default {
    name: "App",
    components: {},
    data: function() {
        return {
            product: {
                id: '',
                array: null,
                variations: 50,
                selected: {},
                initialUnitPrice: 0,
                initialQuantity: null,
                cross: {
                    medias: [],
                    id: '',
                    quantities: new Map(),
                    prices: {},
                    index: 0,
                    label: '',
                    variations: 50,
                    price: 0,
                    htmlClass: 'cs4-productCrossImageWrapper',
                    selectedId: 0,
                    initialQuantities: null,
                    selectedQuantities: []
                }
            },
            input: {
                field: ""
            },
            icons: {
                crystal: `${siteURL}/wp-content/uploads/2019/07/Crystal@2x.png`,
                product: `${siteURL}/wp-content/uploads/2019/09/icon-follower@2x.png`,
                like: `${siteURL}/wp-content/uploads/2020/10/icon_cuore.svg`,
                views: `${siteURL}/wp-content/uploads/2020/12/visual_icon.svg`,
                confirm: `${siteURL}/wp-content/uploads/2019/09/checked@2x.png`
            },
            steps: {
                isFirst: true,
                isSecond: false,
                isLoading: false,
                isAddingToCart: false,
                orderCompleted: false,
            },
            user: {
                medias: [],
                isPrivate: false,
                profilePic: '',
                username: '',
                followers: 0
            },
            errors: {
                noMedia: false,
                notFound: false,
            },
            dictionary: {}
        };
    },
    methods: {
        getProductInfo: async function() {
            return axios.get(this.getProductApiURL()).then((res) => {
                this.product.array = res.data.sort(function(product1, product2) {
                    return product1.id < product2.id ? -1 : 1;
                });
            });
        },
        getCrossProductInfo: async function(){
            return axios.get(this.getCrossProductApiURL()).then((res) => {
                this.product.cross.prices = res.data.sort(function(product1, product2) {
                    return product1.id < product2.id ? -1 : 1;
                }).map(product => {
                    return {
                        id: product.id,
                        price: product.price,
                        label: product.attributes.find(attribute => attribute.name === "Variazione").option
                    }
                });
            })
        },
        generateStarForReview: function(dictionary) {
            let givenRating = dictionary.reviewValue;
            let resHtml = `<strong>${givenRating}</strong> ${dictionary.on} 5 `;
            for(let count = 0; count < 5; count++) {
              if(givenRating >= 1){
                resHtml += `<img class="cs4-star" src="${dictionary.fullStarIcon}" alt="star">`
              } else if( givenRating >= 0.5 && givenRating < 1) {
                resHtml += `<img class="cs4-star" src="${dictionary.halfStarIcon}" alt="star">`
              } else {
                resHtml += `<img class="cs4-star" src="${dictionary.emptyStarIcon}" alt="star">`
              }
              givenRating--;
            }
            resHtml += `<div class="cs4-review-section__based-on"> ${dictionary.reviewTotalNumber} ${dictionary.reviewTotalLabel}</div> `;
            return resHtml;
        },
        getProductApiURL: function() {
          return `https://api2.comprasocial.me/products/priceList/${this.product.id}`
        },
        getCrossProductApiURL: function() {
          return `https://api2.comprasocial.me/products/priceList/${this.product.cross.id}`
        },
        getProductQuantity: function(productIndex, cleanFromDots = false) {
            if(productIndex){
                const res = this.product.array[productIndex].attributes.find((el) => el.name == "Quantità").option;
                return cleanFromDots ? res.replace('.','') : res;
            }
            if(this.product.selected && this.product.selected.attributes){
                const res = this.product.selected.attributes.find((el) => el.name == "Quantità").option;
                return cleanFromDots ?  res.replace('.','') : res;
            }
            return 0;
        },
        getProductPrice: function(productIndex){
            if(productIndex){
                const product = this.product.array[productIndex];
                return  product.sale_price ? Number.parseFloat(product.sale_price).toFixed(2) :  Number.parseFloat(product.regular_price).toFixed(2);
            }
            if(this.product.selected && this.product.selected.regular_price) {
                return this.product.selected.sale_price ? Number.parseFloat(this.product.selected.sale_price).toFixed(2) :  Number.parseFloat(this.product.selected.regular_price).toFixed(2);
            }
            return 0.00.toFixed(2)
        },
        getProductCrystal: function(){
            return Math.floor(Number.parseFloat(this.getProductPrice()));
        },
        getProductDiscount: function(){
            const currentProductUnitPrice = this.getProductPrice() / this.getProductQuantity(null, true);
            const decrease = ((this.product.initialUnitPrice - currentProductUnitPrice) / this.product.initialUnitPrice ) * 100;
            return decrease > 0 ? `Sconto: - ${Number.parseInt(decrease)}%` : '';
        },
        setSlider: function(){
            var slider = document.getElementById('cs4-productSlider');
            noUiSlider.create(slider, {
                start: [0],
                range: {
                    'min': 0,
                    'max': this.product.array.length - 1
                },
                connect: "lower",
                tooltips: {to: (sliderValue) => {
                        const index = Math.round(sliderValue);
                        this.product.selected = this.product.array[index];
                        return `<img class="cs4-product-icon" src="${this.icons.product}"/> +${this.getProductQuantity()}`
                    }},
                step: 1
            });
        },
        cleanInputField() {
            this.input.field = this.input.field.replace(" ",'');
            this.input.field = this.input.field.replace(new RegExp('.*tiktok.com/'),'');
            this.input.field = this.input.field.replace(new RegExp('^@'),'');
            this.input.field = this.input.field.replace(new RegExp('/video/.*'),'');
        },
        goToSecondStep: function() {
            this.resetUserInfo();
            if(this.input.field.match('vm.tiktok')){
                this.steps.isLoading = true;
                this.addProductToCart();
                return;
            }
            this.cleanInputField();
            if(this.input.field === "" ) {
                const inputField = document.getElementById("inputField");
                inputField.classList.add("errorBounce");
                setTimeout(function(){
                    inputField.classList.remove("errorBounce");
                }, 1000)
            } else {
                this.steps.isSecond = false;
                this.steps.isFirst = false;
                this.steps.isLoading = true;
                this.setUserData().then(() => {
                    this.steps.isLoading = false;
                    this.steps.isSecond = true;
                    this.product.initialQuantity = parseInt(this.user.followers);
                    this.setCrossProductQuantity();
                }).catch(() => {
                    this.steps.isLoading = false;
                    this.steps.isSecond = true;
                    this.product.initialQuantity = parseInt(this.user.followers);
                })
            }
        },
        setUserData: async function(){
            axios.post(apiURL + apiUserFeedEndpoint, {
                user: this.input.field
            }).then(res => {
                this.user.medias = res.data.videos || [];
                if(this.user.medias.length > 0){
                    setTimeout(() => {this.setSlidingPhotos()}, 500);
                }
            })
            return axios.post(apiURL + apiUserEndpoint, {
                user: this.input.field
            }).then(res => {
                this.user.username = res.data.username;
                this.user.followers = res.data.followers;
                this.user.profilePic = res.data.avatar;
                this.user.isPrivate = res.data.isPrivate;
            });
        },
        isMediaInCrossMedia: function(media) {
            return this.product.cross.medias.includes(media);
        },
        onMediaClick: function(media) {
            if(this.isMediaInCrossMedia(media)){
                this.product.cross.medias.splice(this.product.cross.medias.findIndex(item => item === media), 1);
            } else {
                this.product.cross.medias.push(media);
            }
        },
        cleanNumberFromDots(stringNumber){
            return stringNumber.replace('.','');
        },
        initCrossProduct: function(){
            this.product.cross.quantities.set('50', [0,50,100]);
            this.product.cross.quantities.set('100', [0,50,100]);
            this.product.cross.quantities.set('250', [0,50,100]);
            this.product.cross.quantities.set('500', [0,50,100]);
            this.product.cross.quantities.set('750', [1,100, 250]);
            this.product.cross.quantities.set('1000', [1,100, 250]);
            this.product.cross.quantities.set('1500', [1,100, 250]);
            this.product.cross.quantities.set('2500', [2,100, 500]);
            this.product.cross.quantities.set('5000', [2,100, 500]);
            this.product.cross.quantities.set('7500', [3, 250, 500]);
            this.product.cross.quantities.set('10000', [3, 250, 500]);
        },
        setCrossProductQuantity(){
            const selectedCrossInfo = this.product.cross.quantities.get(this.getProductQuantity(null,true));
            this.product.cross.index = selectedCrossInfo[0];
            this.product.cross.selectedQuantities = [selectedCrossInfo[1],selectedCrossInfo[2]]
            const selectedCrossProduct = this.product.cross.prices[this.product.cross.index];
            this.product.cross.price = selectedCrossProduct.price;
            this.product.cross.selectedId = selectedCrossProduct.id;
            this.product.cross.label = selectedCrossProduct.label;
        },
        goToFirstStep(){
            this.product.selected = {};
            this.product.cross.medias = [];
            this.product.cross.index = 0;
            this.product.cross.price = 0;
            this.product.initialQuantity = null;
            this.product.cross.initialQuantities = null;
            this.input.field = "";
            this.steps.isSecond = false;
            this.steps.isFirst = true;
            this.steps.isAddingToCart = false;
            this.steps.orderCompleted = false
            this.resetUserInfo();
            setTimeout(() => this.setSlider(),100);
        },
        resetUserInfo() {
            this.user = {
                medias: [],
                isPrivate: false,
                profilePic: '',
                username: '',
                followers: 0
            }
        },
        increaseCartItemCounter() {
            const cartItemCounter = document.getElementById('cs-header__cartCounter');
            cartItemCounter.innerText = parseInt(cartItemCounter.innerText) + 1;
        },
        addProductToCart: async function() {
            this.steps.isLoading = true;
            this.steps.isSecond = false;
            this.steps.isFirst = false;
            this.steps.isAddingToCart = true;
            if(this.product.cross.medias.length > 0) {
                for(let media of this.product.cross.medias){
                    const crossRequestFormData =  new URLSearchParams();
                    crossRequestFormData.append('action','woocommerce_ajax_add_to_cart');
                    crossRequestFormData.append('product_id', this.product.cross.selectedId);
                    crossRequestFormData.append('product_qty', 1);
                    crossRequestFormData.append('links', media.videoUrl);
                    crossRequestFormData.append('initialQuantities', `${media.likes},${media.views}`);
                    // eslint-disable-next-line no-undef
                    await axios.post(wc_add_to_cart_params.ajax_url, crossRequestFormData, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    });
                }
                this.increaseCartItemCounter();
            }

            var productRequestFormData = new URLSearchParams();
            productRequestFormData.append('action','woocommerce_ajax_add_to_cart');
            productRequestFormData.append('product_id', this.product.selected.id);
            productRequestFormData.append('product_qty', 1);
            productRequestFormData.append('links', this.input.field);
            if(this.product.initialQuantity !== null){
                productRequestFormData.append('initialQuantities', this.product.initialQuantity);
            }
            // eslint-disable-next-line no-undef
            await axios.post( wc_add_to_cart_params.ajax_url, productRequestFormData,{
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            this.increaseCartItemCounter();
            this.steps.isLoading = false;
            this.steps.isAddingToCart = false;
            this.steps.orderCompleted = true;
        },
        continueToBuy(){
            this.goToFirstStep();
        },
        goToCheckout(){
            const cartButton = document.getElementsByClassName('cs-header__cartWrapper')[0];
            cartButton.click();
        },
        setSlidingPhotos() {
            const slider = document.querySelector('.cs4-profileVideos');
            let isDown = false;
            let startX;
            let scrollLeft;
            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                slider.classList.add('active');
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener('mouseleave', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mouseup', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mousemove', (e) => {
                if(!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 1.5; //scroll-fast
                slider.scrollLeft = scrollLeft - walk;
            });
        }
    },
    mounted: function() {
        this.steps.isFirst = false;
        this.steps.isLoading = true;
        // eslint-disable-next-line no-undef
        axios.get(  siteURL + '/wp-content/themes/cs-theme/assets/sliders-dictionaries/tiktok/follower/dictionary-' + currentLanguage + '.json').then(
            res => {
                this.dictionary = res.data;
                this.product.id = this.dictionary.productID;
                this.product.cross.id = this.dictionary.crossProductID;
                this.steps.isFirst = true;
                this.steps.isLoading = false;
                this.getProductInfo().then(() => {
                    this.initCrossProduct();
                    this.setSlider();
                    this.product.initialUnitPrice = this.getProductPrice(0) / this.getProductQuantity(0);
                });
                this.getCrossProductInfo();
            }
        )
    },
};
